import { useLocation } from "react-router-dom";

export function PlaceholderPage({ titulo }: { titulo: string }) {
  const { pathname } = useLocation();
  return (
    <div className="container-prose py-16">
      <span className="chip-vacio">⚫ En construcción</span>
      <h1 className="mt-4 font-serif text-4xl text-ink-50">{titulo}</h1>
      <p className="mt-4 max-w-2xl text-ink-200">
        Esta sección está siendo construida. Se publicará cuando esté verificada y con fuentes
        primarias.
      </p>
      <code className="mt-4 inline-block text-xs text-ink-400">{pathname}</code>
    </div>
  );
}
